<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <td
              nowrap
              class="text-center align-middle"
              v-for="column in columns"
              :key="column.key"
              :class="{ pointer: column.sort === true, 'table-sorted': sortType === column.key }"
              :width="column.width"
              @click="changeSort(column.key, column.sort)"
            >
              {{ column.label }}
              <span
                class="fas fa-caret-down sorted"
                v-if="column.sort === true && sortType === column.key && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="column.sort === true && sortType === column.key && sortReverse"
              ></span>
              <span
                class="fal fa-sort sort"
                v-if="column.sort === true && sortType !== column.key"
              ></span>
            </td>
            <td nowrap class="text-center align-middle" width="80">Ações</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filters.length > 0">
            <td v-for="(filter, index) in filters" :key="index">
              <input
                v-if="filter.key != 'clearFilter' && filter.key"
                :type="filter.type"
                class="form-control form-control-sm m-input"
                @input="callData"
                v-model="filterData[filter.key]"
                v-b-tooltip.hover
                :title="filter.tooltip ? filter.tooltip : ''"
                @keypress="validateFilter(filter.type, filter.key, $event)"
              />
              <button
                v-if="filter.key == 'clearFilter'"
                type="button"
                class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                @click="clearFilters"
                v-b-tooltip.hover
                title="Clique para limpar os filtros"
              >
                <i class="far fa-eraser"></i> Limpar
              </button>
            </td>
          </tr>
          <tr v-for="(item, index) in data.data" :key="index">
            <td
              class="text-center align-middle"
              v-for="column in columns"
              :key="column.key"
              :width="column.width"
            >
              {{ getItemInfo(item, column.key, column.type) }}
            </td>
            <td v-if="actions.length > 0">
              <a
                v-for="(action, index) in actions"
                :key="index"
                href="#"
                @click.prevent.stop="execAction(item.id, action.key)"
                class="icon-circle ml-1"
                v-b-tooltip.hover
                :title="actions.title"
              >
                <i class="fas" :class="action.icon"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

export default {
  mixins: [validationFilterValueMixin],
  name: 'ListEntitySimple',
  data() {
    return {
      filterData: {},
    };
  },
  props: {
    data: {
      type: [Array, Object],
    },
    filters: {
      type: Array,
    },
    actions: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    sortType: {
      type: [Number, String],
    },
    sortReverse: {
      type: Boolean,
    },
  },
  methods: {
    changeSort(key, sort) {
      if (sort) {
        this.$emit('sortCall', key);
      }
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.$emit('callData', this.filterData);
      }, timeWindow);
    },
    clearFilters() {
      this.filterData = {};
      this.$emit('clearFilters');
    },
    getItemInfo(item, key, type) {
      const itemLevels = key.split('.');
      if (itemLevels.length == 3) {
        return this.applyDataType(item[itemLevels[0]][itemLevels[1]][itemLevels[2]], type);
      }
      if (itemLevels.length == 2) {
        return this.applyDataType(item[itemLevels[0]][itemLevels[1]], type);
      }
      return this.applyDataType(item[itemLevels[0]], type);
    },
    applyDataType(data, type) {
      if (type === 'date') {
        return this.$options.filters.date(data);
      }

      if (type === 'document') {
        data = this.$options.filters.cnpj(data);
        data = this.$options.filters.cpf(data);
        return data;
      }

      return data;
    },
    execAction(id, action) {
      if (action === 'edit') {
        this.$emit('editItem', id);
      }
      if (action === 'delete') {
        this.$emit('deleteItem', id);
      }
    },
    validateFilter(type, key, event) {
      switch (type) {
        case 'number':
          this.validateValueNumber(event);
          break;
        case 'text':
          if (key == 'cpf') {
            this.validateValueFieldCpfCnpj(event);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
